import './button.scss'
import bm from '../utils/bm'

export default function Button({
    children,
    innerRef,
    onNull,
    round,
    square,
    danger,
    active,
    extraClassName,
    valueOption,
    background,
    dim,
    dangerHover,
    ...props
}) {
    return <button className={bm('button', {active, dim, danger, dangerHover, square, round, background}, extraClassName)} {...props} ref={innerRef} tabIndex={props.tabIndex || 0} role="button">
        {children}
    </button>
}
